import {IMuWidget} from "./IMuWidget";
import {AnyElement, MuWidget} from "mu-widget/lib/MuWidget";
import {BaseModule} from "./dms/BaseModule";
import {UiModalContainer} from "./UiModalContainer";
import {UiFlashMessage} from "./UiFlashMessage";
import {UiFlashMessageContainer} from "mu-widget/lib/UiFlashMessage";
import {BaseRouter} from "./BaseRouter";
import {focusFirstVisibleControl} from "./Utils";

export class BaseMuWidget extends MuWidget {

	public rawUploadUrl: string = "/ticket/upload-raw-attach";

	public router: BaseRouter|null = null;

	public getRouter<T = BaseRouter>(): T {
		if (this.router) return this.router as T;
		let w = this.muParent;
		while (w) {
			if ('getRouter' in w) { // @ts-ignore
				return w.getRouter() as T;
			}
			w = w.muParent;
		}
		throw "No router";
	}

	public closeModal(ev: Event|string) {
		//todo: Nové MuWidget
		let sender : HTMLElement|null;
		if (typeof ev === "string") sender = this.ui[ev];
		else sender = ev.currentTarget as HTMLElement;
		while(sender && !sender.classList.contains('modal-b')) sender = sender.parentElement;
		if (sender) sender.style.display = 'none';
		else {
			console.error("No modal", ev);
		}
	}

	public muClear(container : string|AnyElement) {
		if (typeof container === "string") container = this.ui[container];
		(container as AnyElement).innerHTML = "";
	}

	public callMethodInFirstAncestors(methodName: string, ...args: any[]): any
	{
		let w: any = this;
		while (w) {
			if (methodName in w) {
				return (w as any)[methodName](...args);
			}
			w = w.muParent;
		}
	}

	public getPropertyInAncestors(propertyName: string): any
	{
		let w: any = this;
		while (w) {
			if (propertyName in w) {
				return (w as any)[propertyName];
			}
			w = w.muParent;
		}
	}

	public openInModal<T extends MuWidget<BaseModule>|any>(
		widget: string,
		title: string|null = null,
		params: any = {},
		focusFirstInput = true
	): T
	{
		const w = UiModalContainer.open<T>(
			widget,
			title,
			params,
			focusFirstInput
		);
		// @ts-ignore
		w.muParent = params.muParent || this;

		return w;
	}

	setPageTitle(title: string) {
		if (this.muParent.ui.pageTitle) this.muParent.ui.pageTitle.innerText = title;
		const p = document.title.indexOf('|');
		const sufix = p > -1 ? ' ' + document.title.substring(p) : '';
		document.title = title + sufix;
	}

	addFlash(message: string, type: string = "default") {
		UiFlashMessageContainer.instance.add(type, type);
	}

	private initPromise: Promise<void>|null = null;
	public init(): Promise<void> {
		if (!this.initPromise) {
			this.initPromise = this.doInit();
		}
		return this.initPromise;
	}

	/** @virtual */
	protected async doInit(): Promise<void> { }

	public createWidgetIn<T>(
		widget: string,
		container: string|HTMLElement,
		params: any = {},
		tagName: string = "div",
	): T {
		const el = document.createElement(tagName) as AnyElement;
		if (typeof container === "string") {
			if (!(container in this.ui)) throw "Container '" + container + "' not exist.";
			container = this.ui[container];
		}
		container.append(el);
		el.setAttribute("mu-widget", widget);
		const w = this.muActivateWidget(el, {
			widget: widget,
			params: params, // JSON.stringify(params)
		}, params) as unknown as T;
		// @ts-ignore
		el.widget = w;
		// @ts-ignore

		return w;
	}

	public eventPromise(name: string, removeValue: any = undefined): Promise<any> {
		return new Promise((resolve, reject) => {
			this.addEventListener(name, (ev) => resolve(ev!.args[0]));
			this.container.addEventListener('DOMNodeRemoved', () => removeValue !== undefined
				? resolve(removeValue)
				: reject()
			);
		});
	}
}